import { AspectRatio, Box, Flex, Stack } from "@chakra-ui/react";
import PampaImage from "@raiden/library/components/PampaImage";
import useTranslate from "@raiden/library/hooks/useTranslate";
import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import { useIntl } from "react-intl";
import { CenteredContent } from "../../components/CenteredContent";
import { CourbetBlock } from "../../components/CourbetBlock";
import { DataHandler } from "../../components/DataHandler";
import { OurClientsReview } from "../../components/OurClientsReview";
import { PageLayout } from "../../components/PageLayout";
import { Splash } from "../../components/Splash";
import { PostsContentView } from "../Posts/Common/ContentView";

/**
 * @typedef {Object} Props
 * @property {import("swr").SWRResponse<import("@raiden/library/types/Api/ApiResponse").ApiResponse<import("@raiden/library/types/Post").Post>>} swrResponsePost
 * @property {import("swr").SWRResponse<import("@raiden/library/types/Api/ApiResponse").ApiResponse<import("@raiden/library/types/Post").Post[]>>} swrResponsePostArticleReviews
 */

/**
 * @param {Props} props
 */
export function References({ swrResponsePost, swrResponsePostArticleReviews }) {
  const intl = useIntl();

  const translate = useTranslate();

  const postData = swrResponsePost.data?.data;
  const cover = postData?.current_revision?.cover;
  const caption = cover?.caption ? translate(cover.caption) ?? "" : "";

  return (
    <PageLayout
      title={
        translate(postData?.current_revision?.title) ??
        intl.formatMessage({ defaultMessage: "Références" })
      }
      subtitle={
        translate(postData?.current_revision?.subtitle) ??
        intl.formatMessage({
          defaultMessage:
            "Les avis de nos clients et médias qui nous font confiance",
        })
      }>
      <Box px=".625rem">
        <CenteredContent>
          <Stack spacing="1.5rem">
            <DataHandler
              swrResponse={swrResponsePost}
              keepDataOnRevalidation={true}
              noResult={
                <Flex alignItems="center" flexDir="column" gap="1rem" mx="auto">
                  <Box width={{ base: "200px", lg: "700px" }}>
                    <Splash
                      src={generateFrontPath({
                        id: "@front.internal-assets",
                        parameters: { filePath: "illustrations/error.svg" },
                        includeBasePath: true,
                      })}
                      title={intl.formatMessage({
                        defaultMessage: "Erreur lors du chargement de la page",
                      })}
                    />
                  </Box>
                </Flex>
              }>
              {({ data: post }) => (
                <Box>
                  {cover && (
                    <AspectRatio ratio={1360 / 570}>
                      <PampaImage
                        image={post.current_revision?.cover}
                        format="default"
                        mode="crop"
                        placeholderSrc={generateFrontPath({
                          id: "@front.internal-assets",
                          parameters: { filePath: "placeholder.png" },
                          includeBasePath: true,
                        })}
                        alt={caption}
                      />
                    </AspectRatio>
                  )}

                  <PostsContentView post={post ?? undefined} />

                  <OurClientsReview
                    swrResponsePostArticleReviews={
                      swrResponsePostArticleReviews
                    }
                  />
                </Box>
              )}
            </DataHandler>

            <CourbetBlock />
          </Stack>
        </CenteredContent>
      </Box>
    </PageLayout>
  );
}
